<div class="box-body">
  <div class="alert alert-warning alert-dismissible">
    <h1><i class="icon fa fa-ban"></i>404 NOT FOUND</h1>
  </div>
</div>
